import React, { useEffect, useRef, useState } from 'react';
import config from '../../config';

const FancyNoValueBox = ({
  value,
  checkMaxOdds,
  validation,
  getLock,
  handleOnBackClick,
  isFancySuspend,
  isOddEven=false
}) => {
  const [highlightClass, setHighlightClass] = useState('');
  const prevValueRef = useRef({ noValue: null, noRate: null });
  const firstRender = useRef(true);

  const formatNumberNotFiex = (num) => {
    if (num >= 10000000) {
       return (num / 10000000).toFixed(2) + 'Cr'; // Crore
    } else if (num >= 100000) {
       return (num / 100000).toFixed(2) + 'L'; // Lakh
    } else if (num >= 1000) {
       return (num / 1000).toFixed(2) + 'K'; // Thousand
    } else {
       return num.toString(); // Less than 1000
    }
 };

  const formatNumber = (num) => {
    if (num >= 1000000000) {
       return (num / 1000000000).toFixed(2) + 'B'; // Billion
    } else if (num >= 1000000) {
       return (num / 1000000).toFixed(2) + 'M'; // Million
    } else if (num >= 1000) {
       return (num / 1000).toFixed(2) + 'K'; // Thousand
    } else {
       return num; // Less than 1000
    }
 };

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      prevValueRef.current = {
        noValue: value.noValue,
        noRate: value.noRate,
      };
      return;
    }

    const current = { noValue: value.noValue, noRate: value.noRate };
    const prev = prevValueRef.current;

    if (current.noValue !== prev.noValue || current.noRate !== prev.noRate) {
      if (current.noValue > prev.noValue || current.noRate > prev.noRate) {
        setHighlightClass('higilighted');
      } else if (current.noValue < prev.noValue || current.noRate < prev.noRate) {
        setHighlightClass('higilighted');
      }

      prevValueRef.current = current;

      setTimeout(() => {
        setHighlightClass('');
      }, 500);
    }
  }, [value.noValue, value.noRate]);

  const disabled = checkMaxOdds(value?.marketId, value.noValue ?? 0);

  return (
    <span
      className={`${isOddEven ? 'blue' :'pink'} ${disabled ? '' : 'disable'} ${highlightClass}`}
      onClick={() => validation(value.noValue) ?
        handleOnBackClick(value, config.lay, value?.marketId, value.noValue, config.fancy, config.FANCY, value,isOddEven):''
      }
    >
      {isOddEven ? validation(value.noValue) && !isFancySuspend(value) ? formatNumberNotFiex(value.noRate) : getLock() :validation(value.noValue) && !isFancySuspend(value) ? value.noValue : getLock()}
      {isOddEven ? "" : <small>{validation(value.noValue) && !isFancySuspend(value) ? formatNumberNotFiex(value.noRate) : ''}</small>}
    </span>
  );
};

export default FancyNoValueBox;
